const axios = window.axios;

const search_by = {
  authors: 'authors',
  landings: 'landings',
  articles: 'articles'
}

$(function () {
  const $filterBy = $('.js-search__item');
  const $results = $('.js-search-results');
  const $loadMore = $('.js-search-load-more');
  const $loader = $('.js-search-loader');
  const $close = $('.js-search__close');

  let query = '';
  let page = 1;
  let currentFilter = search_by.landings;

  function clearResults() {
    $results.html('');
    page = 1;
  }

  function search(query, options = {}) {
    const { searchBy = search_by.landings, page = 1 } = options

    $loader.show();
    $loadMore.hide();

    return axios.get(`/search/${searchBy}`, {
      params: {
        q: query,
        page: page
      }
    }).then(function (response) {
      if (response.status === 200) {
        const responseData = response.data,
          responseHtml = responseData.html;
        if (!responseHtml) {
          return $loader.hide();
        }
        $loader.hide();
        if (!responseData.is_last) { $loadMore.show(); }
        $results.append(responseHtml);
      }
    }).catch(alert)
  }

  $close.click(function (e) {
    $('.search-result').hide();
    $('.js-search__item').removeClass('active');
    $('.js-search__item[data-filter="landings"]').addClass('active');
    currentFilter = search_by.landings;
  })

  $filterBy.click(function (e) {
    
    const $this = $(this)
    if ($this.hasClass('active')) { return; }
    clearResults();

    $filterBy.removeClass('active')
    $this.addClass('active')

    const filterValue = $this.data('filter') || search_by.landings;
    currentFilter = filterValue
    search(query, { searchBy: filterValue })
  })

  $loadMore.click(function (e) {
    page += 1;
    search(query, { page: page, searchBy: currentFilter })
  })

  let processing = false;
  $('.js-search-form').submit(async function (e) {
    e.preventDefault();
    if (processing) { return false; }
    clearResults();

    query = $('.js-search-query').val();
    if (!query) { return null; }
    $('.search-result').show();

    processing = true;
    await search(query, { searchBy: currentFilter })
    processing = false;
  })
})